<form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">



  <!--<div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px">
          Profile Header
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
        </div>
        <div class="card-body card-body-general">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="profileTitle"><span>*</span> Title </label>
              </div>
              <div class="col-md-8">

                <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       [(ngModel)]="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       name="CurrentActorPersonalDetailInfoRequest.ProfileTitle"
                       placeholder="Title" maxlength="50" minlength="1" #ProfileTitle="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$" required>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileTitle.valid && (ProfileTitle.dirty || ProfileTitle.touched) && ProfileTitle.errors.required )">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileTitle.valid && ProfileTitle.errors.pattern)">(special characters are not allowed)</small>

              </div>
            </div>

          </div>
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right">
                <label for="profileSummary">Summary</label>
              </div>
              <div class="col-md-8">
                <textarea class="form-control" rows="2" placeholder="Summary" id="CurrentActorPersonalDetailInfoRequest.ProfileSummary"
                          [(ngModel)]="CurrentActorPersonalDetailInfoRequest.ProfileSummary"
                          name="CurrentActorPersonalDetailInfoRequest.ProfileSummary" maxlength="1000" #ProfileSummary="ngModel"
                          pattern="^[\sa-zA-Z0-9,._\-?]*$"></textarea>
                <small class="form-text text-danger"
                       *ngIf="(!ProfileSummary.valid && ProfileSummary.errors.pattern)">(special characters are not allowed)</small>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>-->

  <div class="row" *ngIf="SelectedPatientGuarianDetails">
    <div class="col-md-4 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          General
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 padding-right-0px text-align-left">
                  <span class="spandata2">{{SelectedPatientGuarianDetails.DisplayName}}</span>
                  <div>
                    <label>{{SelectedPatientGuarianDetails.RelationShip}}</label>
                  </div>

                </div>
                <!--<div class="col-md-5 text-align-right">
                  <label>{{SelectedPatientGuarianDetails.DisplayName}}</label>
                </div>-->
                <!--<div class="col-md-3">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         name="CurrentActorPersonalDetailInfoRequest.MiddleName"
                         placeholder="Middle Name" maxlength="20" pattern="^[\sa-zA-Z0-9,._\-?]*$" #MiddleName="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!MiddleName.valid && MiddleName.errors.pattern)">(special characters are not allowed)</small>

                </div>
                <div class="col-md-3">


                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.LastName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.LastName"
                         name="CurrentActorPersonalDetailInfoRequest.LastName"
                         placeholder="Last Name" required maxlength="20" minlength="1" #LastName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                  <small class="form-text text-danger"
                         *ngIf="(!LastName.valid && (LastName.dirty || LastName.touched) && LastName.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!LastName.valid && LastName.errors.pattern)">(special characters are not allowed)</small>

                </div>-->
              </div>

            </div>
          </div>


          <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 padding-right-0px text-align-left">

                </div>


              </div>


            </div>
          </div>-->
        </div>
      </div>
    </div>



    <div class="col-md-4 col-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          Address
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row text-align-left">
                <div class="col-md-8 padding-right-0px">
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px padding-left-17px">
                      <label class="margin-bottom-0px"> {{SelectedPatientGuarianDetails.AddressLine1}},</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px">
                      <label class="margin-bottom-0px">{{SelectedPatientGuarianDetails.AddressLine2}}, {{SelectedPatientGuarianDetails.City}}-</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12 padding-right-0px">
                      <label class="margin-bottom-0px">{{SelectedPatientGuarianDetails.State}}, {{SelectedPatientGuarianDetails.County}}</label>
                    </div>
                  </div>


                </div>
              </div>


            </div>
          </div>


          <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="diaplayName">Zip </label>
                </div>
                <div class="col-md-3">
                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Zip"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Zip"
                         name="CurrentActorPersonalDetailInfoRequest.Zip" #Zip="ngModel" pattern="[0-9]{5}"
                         placeholder="Zip" maxlength="5" />
                  <small class="form-text text-danger"
                         *ngIf="(!Zip.valid && Zip.errors.pattern)">(special characters are not allowed)</small>
                </div>
              </div>


            </div>
          </div>-->


        </div>
      </div>






    </div>
    <div class="col-md-4 col-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header2  padding-left-7px padding-top-6px margin-top-10">
          <div class="row">
            <div class="col-md-5">
              Contact
            </div>
            <div class="col-md-3">
              <a (click)="EditGuardianDetails()" class="nav-link-hand education-navlink float-right date-color-contracts" title="Edit">
                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
              </a>
            </div>
          </div>
          <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->
        </div>
        <div class="card-body card-body-general padding-top-8px">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-1  text-align-center">
                  <label for="diaplayName"> <i class="fas fa-mobile-alt font-size-color"></i> </label>
                </div>:
                <div class="col-md-5 padding-left-2px text-align-left">
                  <!--<input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone1"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone1"
                         mask="(000) 000-0000"
                         name="CurrentActorPersonalDetailInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel"
                         placeholder="Mobile Phone" />
                  <small class="form-text text-danger"
                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                  <label>{{SelectedPatientGuarianDetails.Telephone1}}</label>
                </div>
              </div>


            </div>
          </div>
          <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="diaplayName">Telephone </label>
                </div>
                <div class="col-md-3">
                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone2"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone2"
                         mask="(000) 000-0000"
                         name="CurrentActorPersonalDetailInfoRequest.Telephone2" pattern="[0-9]{10}" #Telephone2="ngModel"
                         placeholder="Telephone" />
                  <small class="form-text text-danger"
                         *ngIf="(!Telephone2.valid)">(Provide Valid Phone No)</small>
                </div>
              </div>


            </div>
          </div>-->
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-1 text-align-left padding-left-13px padding-right-18px">
                  <label for="email address"><i class="fas fa-envelope font-size-color"></i></label>
                </div>:
                <div class="col-md-5 padding-left-2px text-align-left">
                  <!--<input type="email" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Email"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Email"
                         name="CurrentActorPersonalDetailInfoRequest.Email"
                         placeholder="Email" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                         #Email="ngModel" maxlength="30" minlength="4">
                  <small class="form-text text-danger"
                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>-->
                  <label>{{SelectedPatientGuarianDetails.Email}}</label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>





  <!--<div class="row">
    <div class="col-md-12 padding-l-0px">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
        <div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
          Emergency
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
        </div>
        <div class="card-body card-body-general">
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-3 text-align-right">
                  <label for="email address">Contact Person </label>
                </div>
                <div class="col-md-4">
                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName" #EmergencyContactPersonName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         placeholder="Contact Person" maxlength="40" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyContactPersonName.valid && EmergencyContactPersonName.errors.pattern)">(special characters are not allowed)</small>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">

                <div class="col-md-3 text-align-right">
                  <label for="firstName">Contact Number</label>
                </div>
                <div class="col-md-3">

                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1"
                         mask="(000) 000-0000"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1" pattern="[0-9]{10}" #EmergencyContactNo1="ngModel"
                         placeholder="Contact Number" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyContactNo1.valid)">(Provide Valid Contact Number)</small>

                </div>


              </div>


            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="firstName"> Address</label>
                </div>

                <div class="col-md-3">

                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         name="CurrentActorPersonalDetailInfoRequest.EmergencyAddress"
                         placeholder="Address" maxlength="100" #EmergencyAddress="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$" />
                  <small class="form-text text-danger"
                         *ngIf="(!EmergencyAddress.valid && EmergencyAddress.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>
            </div>
          </div>
        </div>




        </div>

            </div>
      </div>-->








  <div class="row" *ngIf="CanEdit === 1 " hidden>
    <div class="card-footer text-right col-12">
      <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

    </div>
  </div>
  <!--<div class="row margin-bottom-10px">
    <div class="col-md-12 padding-lr-0px">
      <div class="card margin-left-zero margin-right">
        <div class="card-body padding-all-0px margin-left-zero">
          <myidentities></myidentities>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-bottom-10px">
    <div class="col-md-12 padding-lr-0px">
      <div class="card margin-lr-19px">
        <div class="card-body padding-all-0px margin-left-zero">
          <resumeupload [ActorCode]='CurrentActorPersonalDetailInfoRequest.ActorCode'></resumeupload>
        </div>
      </div>
    </div>
  </div>-->



</form>
